import React, { useEffect, useRef, useState } from 'react';
import { API_BASE_URL } from '../../constant/constant';

const SettingTools = () => {
  const [localIP, setLocalIP] = useState('');
  const [globalIP, setGlobalIP] = useState('');
  const [deviceName, setDeviceName] = useState('');
  const [ramInfo, setRamInfo] = useState('');
  const[platform,setPlateform]=useState('');
  const [storageInfo, setStorageInfo] = useState('');
  const [systemUptime,setSystemUptime]=useState('');
  const [keyboardStatus, setKeyboardStatus] = useState({
    capsLock: false,
    numLock: false,
    insert: false,
  });
  const [cameraAvailable, setCameraAvailable] = useState(false);
  const [serverData, setServerData] = useState(null);
  const [cameraActive, setCameraActive] = useState(false);
  const videoRef = useRef(null);
  const streamRef = useRef(null);


const formatUptime = (seconds) => {
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  return `${hrs} hours ${mins} minutes`;
};





  // Fetch system info from backend
  useEffect(() => {
    fetch(`${API_BASE_URL}/system-info`)
      .then((res) => res.json())
      .then((data) => {
        setServerData(data);
        setDeviceName(data.hostname || navigator.userAgent);
        setPlateform(`${data.arch} (${data.platform})`);
        setSystemUptime(`${formatUptime(data.uptime)}`)
        setRamInfo(`${data.totalRAM} (Free: ${data.freeRAM})`);
        setStorageInfo(`${data.disk.total} (Free: ${data.disk.free})`);
        if (!localIP && data.localIPs?.[0]) setLocalIP(data.localIPs[0]);
       // if (!globalIP && data.publicIP) setGlobalIP(data.publicIP);
      })
      .catch((err) => {
        console.error('Failed to fetch system info:', err);
        setDeviceName(navigator.userAgent);
        setRamInfo(navigator.deviceMemory ? `${navigator.deviceMemory} GB` : 'Unavailable');
        setStorageInfo('Unavailable');
      });
  }, []);

  // WebRTC fallback for local IP
  useEffect(() => {
    const getLocalIP = async () => {
      try {
        const rtc = new RTCPeerConnection({ iceServers: [] });
        rtc.createDataChannel('');
        rtc.onicecandidate = (event) => {
          if (event.candidate) {
            const ipMatch = event.candidate.candidate.match(/([0-9]{1,3}(\.[0-9]{1,3}){3})/);
            if (ipMatch && !localIP) setLocalIP(ipMatch[1]);
          }
        };
        const offer = await rtc.createOffer();
        await rtc.setLocalDescription(offer);
      } catch {
        setLocalIP('Unavailable');
      }
    };
    getLocalIP();
  }, []);

  // Global IP fallback
  useEffect(() => {
    fetch('https://api.ipify.org?format=json')
      .then((res) => res.json())
      .then((data) => {
        if (!globalIP) setGlobalIP(data.ip);
      })
      .catch(() => setGlobalIP('Unavailable'));
  }, []);

  // Check camera availability
  useEffect(() => {
    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then((stream) => {
        setCameraAvailable(true);
        stream.getTracks().forEach((track) => track.stop());
      })
      .catch(() => setCameraAvailable(false));
  }, []);

  // Keyboard status
  useEffect(() => {
    const handleKey = (e) => {
      setKeyboardStatus({
        capsLock: e.getModifierState('CapsLock'),
        numLock: e.getModifierState('NumLock'),
        insert: e.getModifierState('Insert'),
      });
    };

    window.addEventListener('keydown', handleKey);
    window.addEventListener('keyup', handleKey);

    return () => {
      window.removeEventListener('keydown', handleKey);
      window.removeEventListener('keyup', handleKey);
    };
  }, []);

  // Start camera
  const startCamera = async () => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach((track) => track.stop());
    }

    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        streamRef.current = stream;
        setCameraActive(true);
      }
    } catch (err) {
      console.error('Camera access denied:', err);
    }
  };

  // Stop camera on unmount
  useEffect(() => {
    return () => {
      if (streamRef.current) {
        streamRef.current.getTracks().forEach((track) => track.stop());
      }
    };
  }, []);

  return (
    <div style={{ fontFamily: 'Arial', padding: 20 }}>
      <h2>🛠 System Settings & Status</h2>
      <ul>
        <li><strong>Local IP:</strong> {localIP || 'Loading...'}</li>
        <li><strong>Global IP:</strong> {globalIP || 'Loading...'}</li>
        <li><strong>Device Name:</strong> {deviceName || 'Loading...'} </li>
        <li><strong>CPU:</strong> {serverData?.cpu?.model} ({serverData?.cpu?.cores}  Cores)</li>
        <li><strong>RAM:</strong> {ramInfo || 'Loading...' } </li>
        <li><strong>HDD Info:</strong> {storageInfo || 'Loading...' }  </li>
          <li><strong>Plateform:</strong> {platform || 'Loading...' }  </li>   
           <li><strong>System Uptime:</strong> {systemUptime || 'Loading...' }  </li>   
        <li><strong>Serial Number:</strong> {serverData?.serialNumber || 'Loading...'}</li>
        
        
        <li><strong>Caps Lock:</strong> {keyboardStatus.capsLock ? 'ON' : 'OFF'}</li>
        <li><strong>Num Lock:</strong> {keyboardStatus.numLock ? 'ON' : 'OFF'}</li>
        <li><strong>Insert Key:</strong> {keyboardStatus.insert ? 'ON' : 'OFF'}</li>
        <li><strong>Camera Available:</strong> {cameraAvailable ? 'Yes 🎥' : 'No ❌'}</li>

    <li>
  <strong>Installed Printers:</strong>
  <ul>
    {serverData?.printers?.length > 0
      ? serverData.printers.map((printer, idx) => <li key={idx}>{printer}</li>)
      : <li>None Found</li>}
  </ul>
</li>
<li>
  <strong>Installed Software:</strong>
  <ul style={{ maxHeight: 200, overflowY: 'auto' }}>
    {serverData?.softwareList?.length > 0
      ? serverData.softwareList.map((s, idx) => <li key={idx}>{s}</li>)
      : <li>None Found</li>}
  </ul>
</li>


  <li><strong>You can test these PowerShell commands directly in your terminal</strong></li>
  <ul>powershell "Get-Printer | Select-Object -ExpandProperty Name"</ul>
  <ul>powershell "Get-ItemProperty HKLM:\Software\Microsoft\Windows\CurrentVersion\Uninstall\* | Select-Object -ExpandProperty DisplayName"
</ul>

      </ul>

      <hr />
      <h3>🎥 Camera Preview</h3>
      <button onClick={startCamera} disabled={!cameraAvailable}>
        {cameraActive ? 'Restart Camera' : 'Start Camera'}
      </button>
      <div style={{ marginTop: 10 }}>
        <video
          ref={videoRef}
          autoPlay
          playsInline
          muted
          style={{ width: '100%', maxWidth: 400, border: '2px solid #ccc', borderRadius: 8 }}
        />
      </div>
    </div>
  );
};

export default SettingTools;
